import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/base.service';
import { Employee } from './employee.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class EmployeeService extends BaseService {

    public getEmployees(idToken: string, searchParams: any, pageSize: number, pageIndex: number) {
        let queryParams = new HttpParams();
        queryParams = this.appendQueryParam(queryParams, "last-name", searchParams.lastName);
        queryParams = this.appendQueryParam(queryParams, "first-name", searchParams.firstName);
        queryParams = this.appendQueryParam(queryParams, "business-name", searchParams.businessName);
        queryParams = this.appendQueryParam(queryParams, "email", searchParams.email);
        queryParams = this.appendQueryParam(queryParams, "dealer-id", searchParams.dealerId);
        queryParams = this.appendQueryParam(queryParams, "employee-id", searchParams.employeeId);
        queryParams = this.appendQueryParam(queryParams, "per-page", pageSize);
        queryParams = this.appendQueryParam(queryParams, "page", pageIndex + 1);

        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/employees`, { headers, params: queryParams });
    }

    public getEmployee(idToken: string, id: number): Observable<any>;
    public getEmployee(idToken: string, id: number, includeRoles: boolean): Observable<any>;
    public getEmployee(idToken: string, id: number, includeRoles?: boolean): Observable<any> {
        let queryParams = new HttpParams();
        queryParams = this.appendQueryParam(queryParams, "include-roles", includeRoles);
        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/employee/${id}`, { headers, params: queryParams });
    }

    public addEmployee(idToken: string, employee: Employee) {
        const body = JSON.stringify(employee);
        const headers = this.getHeaders(idToken);
        return this.httpClient.post(`${this.backendDomain}/employee`, body, { headers });
    }

    public updateEmployee(idToken: string, employee: Employee) {
        const body = JSON.stringify(employee);
        const headers = this.getHeaders(idToken);
        return this.httpClient.put(`${this.backendDomain}/employee/${employee.id}`, body, { headers });
    }

    public inactivateEmployee(idToken: string, id: number) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.put(`${this.backendDomain}/employee/inactivate/${id}`, {}, { headers });
    }

    public reactivateEmployee(idToken: string, id: number) {
        // Put must have a body. If there is no body,
        // then for an unknown reason the author
        //const body = {"id": id};
        const headers = this.getHeaders(idToken);
        return this.httpClient.put(`${this.backendDomain}/employee/reactivate/${id}`, {}, { headers });
    }

    public deleteEmployee(idToken: string, id: number) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.delete(`${this.backendDomain}/employee/${id}`, { headers });
    }

    public getEmployeeNames(idToken: string) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/employee-names`, { headers });
    }
}